/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { FC } from 'react';
import { TreeItem, TreeItemProps } from '@mui/x-tree-view';
import { alpha } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { AppVariant, Contract, ListType, Tenant, TreeNodeItem, ValueOf } from '../../types';
import TreeListNodeLabel from './TreeListNodeLabel';

const StyledTreeListItem = withStyles(theme => ({
	root: {},
	iconContainer: {
		'& .close': {
			opacity: 0.3
		}
	},
	group: {
		marginLeft: 7,
		paddingLeft: 18,
		borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`
	}
}))((props: TreeItemProps) => <TreeItem {...props} />);

type TreeListNodeProps = TreeNodeItem<AppVariant | Tenant | Contract> & {
	subItems?: AppVariant[];
	type: ValueOf<typeof ListType>;
};
const TreeListNode: FC<TreeListNodeProps> = ({ type, id, name, subItems }: TreeListNodeProps) => {
	return (
		<StyledTreeListItem nodeId={id} label={<TreeListNodeLabel name={name} id={id} showCheckbox={true} type={type} />}>
			{subItems?.map(subItem => {
				return <TreeListNode key={subItem.id} id={subItem.id} name={subItem.name} type={type} />;
			})}
		</StyledTreeListItem>
	);
};

export default TreeListNode;
